export default __webpack_public_path__ + "static/media/photo--sm--daniel-2.a170b7c1.jpg";